<template>
  <AppContainer>
    <div class="row">
      <h2 class="fw-bold mb-1">Informe o valor que deseja adicionar</h2>
      <div class="col-12 mt-3 form-group">
        <label for="balance-selection" class="form-label">Selecione um valor</label>
        <select class="form-select form-control" id="balance-selection" @change="handleSelectedValue">
          <option :value="value" v-for="value in values">R$ {{ value }}</option>
          <option value="other">Outro</option>
        </select>
      </div>
      <div class="col-12 form-group" v-if="selected_value == 'other'">
        <label for="balane-value-other" class="form-label">Informe o valor</label>
        <input type="text" class="form-control" id="balane-value-other" v-model.trim="$v.balance_value.$model"
          v-money3="moneyMaskConfig" placeholder="Informe o valor que deseja adicionar">
      </div>
      <div class="col-12 form-group">
        <label for="add_credit_card_document" class="form-label">CPF</label>
        <input type="text" class="form-control" v-maska :data-maska="cpfMask" id="add_credit_card_document"
          v-model.trim="$v.document_number.$model" placeholder="999.999.999-99">
      </div>
      <div class="col-12 mt-3">
        <SubmitBtn title="Continuar" class="w-100" id="balance-submit-btn" :loading="submitting" @click="handleContinue" />
      </div>
    </div>
  </AppContainer>
</template>

<script lang="ts" setup>
import { EOffcanvasPage } from '@/components/Offcanvas/canvas.pages';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import useForm from '@/composables/useForm';
import usePayment from '@/composables/usePayment';
import { IBalancePost } from '@/interfaces';
import { keepOnlyNumbers } from '@/utils';
import { addBalanceValidations } from '@/utils/form_validations';
import { cpfMask, moneyMaskConfig } from '@/utils/masks';
import useVuelidate from '@vuelidate/core';
import { computed, ref } from 'vue';

const values = [30, 50, 100, 150, 200]
const { submitting, addBalance, user_document_number } = usePayment()
const { replaceCanvas } = useOffCanvas()
const { invalidForm } = useForm()

const selected_value = ref<number | "other">(0)
const balance_value = ref('30')
const document_number = ref(user_document_number)

const $v = useVuelidate(addBalanceValidations(), { document_number, balance_value })


const handleSelectedValue = (event: any) => {
  const value = event.target.value as number | 'other'
  if (value == selected_value.value) return
  selected_value.value = value
  if (value == "other") {
    balance_value.value = '0'
  } else {
    balance_value.value = value.toString()
  }
}

const form = computed(() => {
  return {
    document_number: document_number.value,
    value: Number(keepOnlyNumbers(balance_value.value)),
    payment_method: 'pix'
  } as IBalancePost
})

const handleContinue = () => {
  $v.value.$touch()
  if (invalidForm($v.value)) {
    return
  }
  addBalance(form.value, (transactionId) => {
    replaceCanvas(EOffcanvasPage.pix_pending_payment, { props: { transactionId } })
  })
}


</script>